import { ReactNode } from 'react';
import { LoadingProvider } from '@/contexts/LoadingContext';
import { GlobalLoadingProvider } from '@/contexts/GlobalLoadingContext';
import { GlobalLoading } from './GlobalLoading';

interface LoadingProviderWithGlobalLoadingProps {
  children: ReactNode;
}

/**
 * LoadingProvider with GlobalLoading component
 * Combines GlobalLoadingProvider, LoadingProvider and GlobalLoading in the correct hierarchy
 * Provides both local and global loading contexts for the application
 */
export function LoadingProviderWithGlobalLoading({
  children
}: LoadingProviderWithGlobalLoadingProps) {
  return (
    <GlobalLoadingProvider>
      <LoadingProvider>
        <GlobalLoading />
        {children}
      </LoadingProvider>
    </GlobalLoadingProvider>
  );
}